var React = require('react');

function IconInformationInline (props) {
    return React.createElement("path",props);
}

IconInformationInline.defaultProps = {"d":"M23.5,11.75 C22.2012333,11.75 21.15,10.6987667 21.15,9.4 C21.15,8.1028 22.2012333,7.05 23.5,7.05 C24.7972,7.05 25.85,8.1028 25.85,9.4 C25.85,10.6987667 24.7972,11.75 23.5,11.75 L23.5,11.75 Z M25.85,37.6 C25.85,38.8540944 24.7972,39.95 23.5,39.95 C22.2028,39.95 21.15,38.8540944 21.15,37.6 L21.15,16.45 C21.15,15.1959056 22.2028,14.1 23.5,14.1 C24.7972,14.1 25.85,15.1959056 25.85,16.45 L25.85,37.6 Z M23.5,0 C10.5201667,0 0,10.5217333 0,23.5 C0,36.4782667 10.5201667,47 23.5,47 C36.4782667,47 47,36.4782667 47,23.5 C47,10.5217333 36.4782667,0 23.5,0 L23.5,0 Z"};

module.exports = IconInformationInline;

IconInformationInline.default = IconInformationInline;
